import script from "./UsageReports.vue?vue&type=script&lang=ts&setup=true"
export * from "./UsageReports.vue?vue&type=script&lang=ts&setup=true"

import "./UsageReports.vue?vue&type=style&index=0&id=722262e0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-722262e0"]])

export default __exports__